import { GALLERY_RAW } from '@/data/galleryRaw';
import { CATEGORIES } from '@/data/categories';
import { HERO_IMAGE, PROJECTS } from '@/data/portfolio';
import { WHY_IMAGE } from '@/data/content';

export const GALLERY_FILTERS = [
  { id: 'all', label: 'Sve' },
  { id: 'V', label: 'Veliki formati i outdoor' },
  { id: 'P', label: 'Brendiranje prostora' },
  { id: 'A', label: 'Vozila' },
  { id: 'T', label: 'Tekstil' },
  { id: 'E', label: 'Event i promo oprema' },
  { id: 'S', label: 'Posebna rješenja' },
];

const LABELS = Object.fromEntries(GALLERY_FILTERS.map((f) => [f.id, f.label]));

// Sve stvarne fotografije radova; kategorija je okvirna i može se ispraviti u galleryRaw.js.
export const GALLERY = GALLERY_RAW.map(([file, category], i) => ({
  id: file,
  category,
  categoryLabel: LABELS[category],
  thumb: `/images/gallery/thumb/${file}`,
  large: `/images/gallery/large/${file}`,
  alt: `Garmond Graphic — ${LABELS[category]}, rad ${i + 1}`,
}));

// Fotografija se na homepageu prikazuje na samo jednom mjestu:
// hero i kartice usluga se nikad ne ponavljaju u galeriji, a izdvojeni projekti
// se izostavljaju iz galerije dok su prikazani (filter "Sve").
const ALWAYS_USED = new Set([HERO_IMAGE.galleryId, WHY_IMAGE.galleryId, ...CATEGORIES.map((c) => c.galleryId)]);
const FEATURED = new Set(PROJECTS.map((p) => p.galleryId));

export const galleryItems = ({ filter, featuredShown }) =>
  GALLERY.filter(
    (g) =>
      (filter === 'all' || g.category === filter) &&
      !ALWAYS_USED.has(g.id) &&
      !(featuredShown && FEATURED.has(g.id))
  );
